import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import { useGetGsAssessment } from '../../../Assessment/graphql';
import { PAGE_TEXT } from '../../../Assessment/lang';
import { GSAssessmentContent } from '../../../Assessment';
import { Loading, Alert, Accordion } from '../../../../components';
import { ApplicationFeePayment } from '../../../Application/components/ApplicationStatus/Payment';
import { PAYMENT_TYPE } from '../../../Application/components';
import { SUMMARY_STATUS_PAGE_TEXT } from '../../../Application/components/ApplicationStatus/lang';

const TITLE =
  PAGE_TEXT.GS_ASSESSMENT_DETAILS.CHECK_STEPPER.OFFER_DECISION.TITLE;

export const GSAssessmentForm: React.FunctionComponent = () => {
  const { applicationId = '' } = useParams();

  const { gsDecision, previewData, loading, error } =
    useGetGsAssessment(applicationId);

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }
  const hasGSAssessmentDone = Boolean(gsDecision?.secondCheckedBy);

  return (
    <>
      {loading ? (
        <Loading />
      ) : hasGSAssessmentDone ? (
        <>
          <GSAssessmentContent
            title={TITLE}
            previewData={previewData}
            remarks={[]} // TODO tbc if display the return history in monitor section
            initialValues={gsDecision}
            isViewMode={true}
          />
          <Accordion
            title={SUMMARY_STATUS_PAGE_TEXT.DEBIT_NOTE}
            details={
              <div className="py-4">
                <ApplicationFeePayment
                  paymentType={PAYMENT_TYPE.REGISTRATION_FEE}
                />
              </div>
            }
          />
        </>
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.GS_DECISION)
      )}
    </>
  );
};
